import { useState, useEffect, useCallback } from 'react';
import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';
import { IOB_GENERATION_DAY_OF_MONTH } from './fteTrackingUtils';

/**
 * The month the NEXT automated IOB run will process, i.e. the month whose unlocked entries the warning
 * badge should count. Runs happen on/after the 7th and always process the previous month: up to and
 * including the 7th (UTC) the imminent run targets last month; after that the next run is next month's,
 * targeting the current month.
 */
function getIobTargetMonth() {
  const now = new Date();
  const target = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  if (now.getUTCDate() <= IOB_GENERATION_DAY_OF_MONTH) {
    target.setUTCMonth(target.getUTCMonth() - 1);
  }
  return { year: target.getUTCFullYear(), month: target.getUTCMonth() + 1 };
}

export default function useFteWarnings() {
  const [warnings, setWarnings] = useState(null);

  const fetchWarnings = useCallback(() => {
    const { year, month } = getIobTargetMonth();
    OutsourcedUserFteService.GetWarnings(year, month)
      .then((response) => {
        if (response && !response.error) {
          setWarnings(response);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchWarnings();
  }, [fetchWarnings]);

  return { warnings, refreshWarnings: fetchWarnings };
}
